import { RateVersion, rateVersionValidationSchema } from './RateVersionApiEndpoints';
import { useMyTimezone } from 'components/customer/orgs/MyOrgAPIEndpoints';
//@ts-ignore
import { convertToLocalTime } from "lib/DateRuleSetFormatter";
//@ts-ignore
import { getDateFromMui } from "lib/Formatters"
import { Formik, Form, Field } from 'formik';
import React, { useRef, useEffect } from 'react';
import { TextField } from 'formik-mui';
import { Grid } from '@mui/material';
import { UcDatePickerFormik } from 'components/common/UcDatePicker';
import { useTranslation } from "react-i18next";
//@ts-ignore
import { DateTime } from 'luxon';

export interface RateVersionDuplicationFormProps {
    itemToEdit: RateVersion,
    setVersionOverlap: Function,
    rateVersions: any;
    dialogSubmit: any;
    onSubmit: any;
    disabled?: boolean;
    onError: any;
}

export const RateVersionDuplicationForm = (props: RateVersionDuplicationFormProps) => {
    const { itemToEdit, setVersionOverlap, rateVersions } = props;
    const { t } = useTranslation();
    const timezone = useMyTimezone();
    const dialogSubmit = useRef(props.dialogSubmit);
    const formRef = useRef<any>();
    const [startDate, setStartDate] = React.useState(itemToEdit.startDate || DateTime.now().toISO());
    const [endDate, setEndDate] = React.useState(itemToEdit.endDate || DateTime.now().toISO());
    setVersionOverlap(0);   

    if (rateVersions?.length > 0) {
        rateVersions.forEach((item: RateVersion) => {
            if (new Date(startDate) <= new Date(item.endDate) && new Date(item.startDate) <= new Date(endDate)) {
                props.setVersionOverlap((versionOverlap: number) => versionOverlap + 1);
            }
        });
    }

    const handleChangeStartDate = (value: any) => {
        if (formRef.current !== undefined) {
            formRef.current.setFieldValue('startDate', convertToLocalTime(getDateFromMui(value), timezone));
            setStartDate(DateTime.fromJSDate(new Date(value)).toUTC().toISO());
        }
    }

    const handleChangeEndDate = (value: any) => {
        if (formRef.current !== undefined) {
            formRef.current.setFieldValue('endDate', convertToLocalTime(getDateFromMui(value), timezone));
            setEndDate(DateTime.fromJSDate(new Date(value)).toUTC().toISO());
        }
    }

    useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            if (formRef.current) {
                formRef.current.handleSubmit();
            }
        }
    });

    return (
        <div className='ignoreCustomFormStyles'>
            <Formik
                innerRef={formRef}
                initialValues={{
                    ...itemToEdit,
                    name: '',
                }}
                validationSchema={rateVersionValidationSchema}
                onSubmit={(values) => {
                    try {
                        props.onSubmit(values);
                    } catch (error) {
                        props.onError(error);
                    }
                }}
            >
                <Form>
                    <Grid container spacing={2} style={{paddingTop: '8px'}}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Field
                                fullWidth
                                name={"name"}
                                component={TextField}
                                disabled={props.disabled}
                                label={t("New Rate Name")}                              
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Field
                                fullWidth
                                name={"description"}
                                component={TextField}
                                multiline
                                rows={4}
                                disabled={props.disabled}
                                label={t("New Rate Description")}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Field
                                fullWidth
                                name={"startDate"}
                                dateOnly={true}
                                component={UcDatePickerFormik}
                                disabled={props.disabled}
                                label={t("Start Date")}
                                sendValueToForm={handleChangeStartDate}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Field
                                fullWidth
                                name={"endDate"}
                                dateOnly={true}
                                component={UcDatePickerFormik}
                                disabled={props.disabled}
                                label={t("End Date")}
                                sendValueToForm={handleChangeEndDate}
                            />
                        </Grid>
                    </Grid>
                </Form>
            </Formik>
        </div>
    );
}